import { useI18n } from '@app-velocity/i18n';
import { AddIcon } from '@app-velocity/icons';
import { MessageBus } from '@app-velocity/message-bus';
import { Button } from '@app-velocity/ui';

import { useTeamAdminContext } from '../../../../../../context/useTeamAdminContext';
import { useTeamAccess } from '../../../../../../hooks';

const messageBus = new MessageBus('teams');

export const InviteUsersButton = () => {
  const { team } = useTeamAdminContext();
  const { canInviteMembers } = useTeamAccess();
  const { t } = useI18n();

  const openModal = () => {
    if (!team.id) return;

    if (!canInviteMembers) {
      messageBus.publish('modal:upgrade-to-invite:open');

      return;
    }

    messageBus.publish('modal:invite-members:open', { teamId: team.id });
  };

  return (
    <Button
      variant="contained"
      color="primary"
      size="small"
      onClick={openModal}
    >
      <AddIcon /> {t('teams:invite_users')}
    </Button>
  );
};
